import React from "react";
import {ThemeProvider} from "@chakra-ui/core";

import {ClientTenant, Context, State} from "./types";

import getTheme from "~/theme";
import {ColorModeProvider} from "~/ui/colorMode";

interface Props {
  initialValue: ClientTenant;
}

const TenantContext = React.createContext({} as Context);

const TenantProvider: React.FC<Props> = ({children, initialValue: tenant}) => {
  const state: State = {tenant};

  return (
    <ThemeProvider theme={getTheme(tenant.color)}>
      <ColorModeProvider
        color={tenant.color}
        defaultValue={tenant.flags?.includes("darkMode") ? "dark" : "light"}
        storageKey={`pency-color-mode:${tenant.slug}`}
      >
        <TenantContext.Provider value={{state}}>{children}</TenantContext.Provider>
      </ColorModeProvider>
    </ThemeProvider>
  );
};

export {TenantProvider as Provider, TenantContext as default};
